<template>
  <div class="solicitud">
    <nueva-solicitud />
  </div>
</template>

<script>
import nuevaSolicitud from '@/components/forms/NuevaSolicitud'
import { mapActions } from 'vuex'

export default {
  data () {
    return {

    }
  },
  components: {
    nuevaSolicitud
  },
  methods: {
    ...mapActions(['fetchDeptos', 'fetchCiudades', 'fetchBarrios'])
  },
  mounted () {
    this.fetchDeptos()
    this.fetchCiudades()
    this.fetchBarrios()
  }
}
</script>
